import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg"><g fillRule="evenodd" clipRule="evenodd" fill="#fff"><path d="M15.625 5.804a.625.625 0 010 1.25H4.375a.625.625 0 010-1.25h11.25zM15.625 9.375a.625.625 0 010 1.25H4.375a.625.625 0 110-1.25h11.25zM15.625 12.946a.625.625 0 010 1.25H4.375a.625.625 0 010-1.25h11.25z" /></g></svg>;
}
export default SvgComponent;